<div class="overlay-loader" *ngIf="isLoading">
  <div class="spinner-box">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
 <nav class="breadcrumb">
 <a (click)="goToDashboard()">Purchase Orders</a>
  <span>/</span>
  <span>Order Details - {{orderId}}</span>
</nav>
<div class="orders-container" *ngIf="orderDetails$ | async as order">
 
  <mat-card>
    <mat-card-title>Order Details</mat-card-title>
    <mat-card-content>
      <!-- <table mat-table [dataSource]="order" class="mat-elevation-z2 orders-table"> -->
      <table mat-table [dataSource]="order | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
        class="mat-elevation-z2 orders-table">
        <ng-container matColumnDef="slno">
          <th mat-header-cell *matHeaderCellDef> Sl No. </th>
          <td mat-cell *matCellDef="let order; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Number </th>
          <td mat-cell *matCellDef="let order">
            {{ order.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let order"> {{ order.date | date:'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="amount_untaxed">
          <th mat-header-cell *matHeaderCellDef> Value </th>
          <td mat-cell *matCellDef="let order"> {{order.currency}} {{ order.amount_residual }} </td>
        </ng-container>
        <!-- <ng-container matColumnDef="payment_status">
          <th mat-header-cell *matHeaderCellDef> Bill Status </th>
          <td mat-cell *matCellDef="let order"> {{ order.payment_status }} </td>
        </ng-container> -->


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [length]="order.length" *ngIf="order.length > 5" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons (page)="onPageChange($event)">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>